import { LoadLang } from "../localstate"
export const DEFAULT_LANGUAGE = LoadLang() ?? 'az'
export const FALLBACK_LANGUAGE = LoadLang()?.toLowerCase()
export const SUPPORTED_LANGUAGES = ['en', 'az']